"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const tag_1 = require("components/cosmos/tag");
const translate_1 = require("components/translate");
const DefaultClass = ({ name, isDefault }) => {
    if (!isDefault) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: name });
    }
    return ((0, jsx_runtime_1.jsxs)("span", { className: "_d-flex _align-items-center", children: [name, (0, jsx_runtime_1.jsx)(tag_1.Tag, { variation: "blue", size: "sm", className: "_ml-2", children: (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: "general.default_class_label", checkOnlineEvent: true }) })] }));
};
exports.default = DefaultClass;
